// Mixpanel product-analytics setup for House of Stox.
//
// Code-level SDK per Mixpanel's implementation guide. GA4, Meta and Google Ads
// are handled separately via GTM (the dataLayer); Mixpanel here powers product
// funnels, retention, cohorts and session replay. Events are forwarded from the
// central track() util (src/utils/track.js) so we reuse the same instrumentation.
import mixpanel from "mixpanel-browser";

const TOKEN =
  process.env.REACT_APP_MIXPANEL_TOKEN || "ca643344f66eca4df7c441941a15fada";

let started = false;

export function initMixpanel() {
  if (started || typeof window === "undefined" || !TOKEN) return;
  try {
    mixpanel.init(TOKEN, {
      // EU data residency — the House of Stox project lives on eu.mixpanel.com,
      // so events AND session replay must be sent to the EU ingestion endpoint.
      api_host: "https://api-eu.mixpanel.com",
      debug: process.env.NODE_ENV !== "production",
      persistence: "localStorage",
      track_pageview: false, // we send our own marketplace events
      record_sessions_percent: 100, // session replay (already used on the site)
      ignore_dnt: false,
    });
    started = true;
    mixpanel.register({ platform: "web" }); // super property on every event
    // Restore identity if the user is already logged in (per Mixpanel guide).
    try {
      const stored = JSON.parse(localStorage.getItem("userData") || "null");
      const uid = stored && (stored.id || stored._id || stored.user_id);
      if (uid) mixpanel.identify(String(uid));
    } catch (e) {}
  } catch (e) {}
}

export function mpTrack(event, props) {
  if (!started || !event) return;
  try {
    mixpanel.track(event, props || {});
  } catch (e) {}
}

export function mpIdentify(userId, profile) {
  if (!started || !userId) return;
  try {
    mixpanel.identify(String(userId));
    if (profile) {
      const p = {};
      Object.keys(profile).forEach((k) => {
        const v = profile[k];
        if (v !== undefined && v !== null && v !== "") p[k] = v; // omit empties
      });
      mixpanel.people.set(p);
    }
  } catch (e) {}
}

export function mpReset() {
  if (!started) return;
  try {
    mixpanel.reset(); // clear identity + super props on logout
  } catch (e) {}
}
